import * as React from 'react';

const QUESTIONS = [
  {
    q: '¿Puedo mandar el pedido a una dirección que no es la mía?',
    a: 'Sí. En tu cuenta guardás todas las direcciones que quieras y elegís a cuál va cada pedido. Podés pedir para ellos hoy y para tu casa mañana.',
  },
  {
    q: '¿Tienen que estar en la casa para recibirlo?',
    a: 'Sí, alguien tiene que recibir el pedido. Por eso elegís vos el día y la franja horaria: para que sea un momento en que sabés que están.',
  },
  {
    q: '¿Y si llega algo en mal estado?',
    a: 'Escribinos por WhatsApp y lo resolvemos: reponemos el producto en la siguiente entrega o te lo acreditamos.',
  },
  {
    q: '¿A dónde entregan?',
    a: 'Córdoba capital y alrededores. Si no estás seguro de que llegamos a esa dirección, escribinos y te confirmamos antes de que hagas el pedido.',
  },
];

export function FAQ() {
  return (
    <section className="sq-faq">
      <style>{`
        .sq-faq {
          padding: 72px 24px;
          background: #fff;
        }
        .sq-faq-inner {
          max-width: 760px;
          margin: 0 auto;
        }
        .sq-faq h2 {
          font-size: 30px;
          font-weight: 800;
          color: #1a1a1a;
          text-align: center;
          margin: 0 0 40px;
        }
        .sq-faq-item {
          border-bottom: 1px solid #eee;
          padding: 22px 0;
        }
        .sq-faq-item:last-child {
          border-bottom: none;
        }
        .sq-faq-item h3 {
          font-size: 18px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 8px;
        }
        .sq-faq-item p {
          font-size: 15px;
          color: #555;
          line-height: 1.7;
          margin: 0;
        }
        @media (max-width: 768px) {
          .sq-faq { padding: 56px 20px; }
          .sq-faq h2 { font-size: 25px; }
        }
      `}</style>

      <div className="sq-faq-inner">
        <h2>Preguntas frecuentes</h2>
        {QUESTIONS.map((item) => (
          <div className="sq-faq-item" key={item.q}>
            <h3>{item.q}</h3>
            <p>{item.a}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
